export const POSTAL_CODE_LENGTH = 5;

export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const PHONE_REGEX = /^\+[\d]{1,3}\d{10}$/;

export const RFC_REGEX = /^[A-ZÑ&]{3,4}\d{6}[A-Z0-9]{3}?$/;

export const POSTAL_CODE_REGEX = /^\d{5}$/;

export const POSTAL_CODE_CDMX_REGEX = /^(0[1-9]\d{3}|1[0-6]\d{3})$/;

export const PASSWORD_REGEX =
  /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[\W_]).{8,15}$/;

export const wrongPasswordMessage =
  'Debe contener entre 8 y 15 caracteres, una letra mayúscula, minúscula, un número y un carácter especial';
